import { FormikProps } from 'formik';
import { QuestionFormValues } from '@/utils/forms/questionTransformers';
import { QuestionBasicFields } from './QuestionBasicFields';
import { QuestionTextFields } from './QuestionTextFields';
import { QuestionSubtextFields } from './QuestionSubtextFields';
import { QuestionImageFields } from './QuestionImageFields';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';

interface QuestionFieldsSectionProps {
  formik: FormikProps<QuestionFormValues>;
  pickems: Array<{ pickem_id: string; title_en?: string; title_fr?: string }>;
  translateField: (
    sourceKey: string,
    sourceValue: string,
    targetKey: string,
    setFieldValue: any
  ) => void;
  isFieldTranslating: (key: string) => boolean;
  isEditable: boolean;
  isNewQuestion: boolean;
}

export function QuestionFieldsSection({
  formik,
  pickems,
  translateField,
  isFieldTranslating,
  isEditable,
  isNewQuestion,
}: QuestionFieldsSectionProps) {
  return (
    <>
      <QuestionBasicFields
        formik={formik}
        pickems={pickems}
        isEditable={isEditable}
        isNewQuestion={isNewQuestion}
      />

      {/* English/French tabs for translatable fields */}
      <Tabs defaultValue="en" className="w-full">
        <TabsList>
          <TabsTrigger value="en">English</TabsTrigger>
          <TabsTrigger value="fr">French</TabsTrigger>
        </TabsList>

        <TabsContent value="en" className="flex flex-col gap-4">
          <QuestionTextFields
            formik={formik}
            translateField={translateField}
            isFieldTranslating={isFieldTranslating}
            isEditable={isEditable}
            language="en"
          />
          <QuestionSubtextFields
            formik={formik}
            translateField={translateField}
            isFieldTranslating={isFieldTranslating}
            isEditable={isEditable}
            language="en"
          />
          <QuestionImageFields formik={formik} isEditable={isEditable} language="en" />
        </TabsContent>

        <TabsContent value="fr" className="flex flex-col gap-4">
          <QuestionTextFields
            formik={formik}
            translateField={translateField}
            isFieldTranslating={isFieldTranslating}
            isEditable={isEditable}
            language="fr"
          />
          <QuestionSubtextFields
            formik={formik}
            translateField={translateField}
            isFieldTranslating={isFieldTranslating}
            isEditable={isEditable}
            language="fr"
          />
          <QuestionImageFields formik={formik} isEditable={isEditable} language="fr" />
        </TabsContent>
      </Tabs>
    </>
  );
}
